import { Tile } from '@components/shared/tile.component';
import React from 'react';

export const CyberAssessmentEmptyState: React.FC = () => {
  return (
    <div className="p-6">
      <Tile
        className="min-h-72"
        emptyState={{
          message:
            'This cyber assessment does not contain any questions. Try creating a new assessment after the cyber catalog is available.',
          title: 'No questions found',
        }}
        isEmpty
      />
    </div>
  );
};
